import * as actionTypes from '../actions/actionTypes'

const initialState = {
  values: [],
  errorMessage: undefined,
}

const taggedInputTextReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TAGGED_INPUT_TEXT_ADD:
      return {
        ...state,
        values: [
          ...state.values,
          action.payload,
        ]
      }
    case actionTypes.TAGGED_INPUT_TEXT_REMOVE:
      const newValues = state.values.filter(a => a.value !== action.payload.value)
      return {
        ...state,
        values: newValues,
      }
    case actionTypes.TAGGED_INPUT_TEXT_RESET:
      return initialState
    default:
      return state
  }
}

export default taggedInputTextReducer



// WEBPACK FOOTER //
// ./src/store/reducers/taggedInputTextReducer.js